import { useContext } from "react";
import { QuestionsContext } from "./QuestionsProvider";
import { Question } from "src/api/types";

export function useQuestions<T>(selector: (question: Question) => T) {
  const question = useContext(QuestionsContext);

  if (question == null) {
    throw new Error("useQuestions is used outside QuestionsProvider");
  }

  return selector(question);
}
